import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the user has zoomed in beyond a certain threshold
 * @param threshold - The zoom threshold (default: 2 for 200% zoom)
 * @returns boolean indicating if the user is zoomed in
 */
export const useZoomDetection = (threshold: number = 2): boolean => {
  const [isZoomedIn, setIsZoomedIn] = useState(false);

  useEffect(() => {
    const checkZoomLevel = () => {
      const zoomLevel = window.devicePixelRatio;
      // Consider zoom levels above threshold as "zoomed in"
      setIsZoomedIn(zoomLevel > threshold);
    };

    checkZoomLevel();
    window.addEventListener('resize', checkZoomLevel);
    
    return () => {
      window.removeEventListener('resize', checkZoomLevel);
    };
  }, [threshold]);

  return isZoomedIn;
}; 